<script lang="ts" setup>
import dayjs from 'dayjs';

defineProps<{
  avatar?: { url: string; thumb_url?: string } | null;
  createdAt: string;
  isAnonymous?: boolean;
  isManager?: boolean;
  name?: string;
}>();
</script>

<template>
  <div class="user-details">
    <div class="user-details__avatar">
      <div
        v-if="isManager"
        class="flex justify-center items-center flex-shrink-0 bg-hell-black rounded-full size-12"
      >
        <SvgoLogoH
          :font-controlled="false"
          class="size-6 text-white"
          filled
        />
      </div>

      <img
        v-else-if="avatar"
        :src="avatar.thumb_url ?? avatar.url"
        alt="user avatar"
        class="user-details__avatar-img"
      />

      <span v-else-if="name && !isAnonymous">
        {{ name.charAt(0) }}
      </span>

      <SvgoProfile
        v-else
        :font-controlled="false"
        class="size-7"
        filled
      />
    </div>

    <div class="user-details__data">
      <div
        :class="{ 'font-bold': isManager }"
        class="text-sm md:text-base break-words"
      >
        {{ isManager ? 'Hellride' : name }}
      </div>

      <div class="text-xs text-hell-black-40">
        {{ dayjs(createdAt).format('DD MMMM YYYY') }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.user-details {
  display: flex;
  gap: 16px;
  align-items: center;

  &__avatar {
    display: flex;
    flex-shrink: 0;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    width: 48px;
    height: 48px;
    border-radius: 100%;
    background-color: $hell-black-10;
    color: $hell-black-60;
    font-weight: $bold;
    font-size: $text-lg;
  }

  &__avatar-img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  &__data {
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: space-between;

    @include screen-sm {
      font-size: $text-base;
    }
  }
}
</style>
